import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetArea[]): IGetArea[] => {
  const dataTableData: IGetArea[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllAreas = async ( {data} : {data: submitFilterDTO | {}}): Promise<IGetArea[]> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Areas` , data);
  return convertToDataTable(response as unknown as IGetArea[]);
};

type QueryFnType = typeof getAllAreas;

type UseGetAllAreasOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAreas = ({ data, config }: UseGetAllAreasOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAreas'],
    queryFn: () => getAllAreas({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};